
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    facetData: {
      type: Object,
      default: () => ({}),
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedCheckbox: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
    }),
    filterValue() {
      return `filter.${this.facetData.field}=${this.filterData.value}`
    },
    searchFilters: {
      get() {
        return this.vxSearchFilters
      },
      set(value) {
        this.vxResetSearchResults('filtering')
        this.vxSetSearchFilters(value)
        this.vxQuerySearchspring()
      },
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetSearchFilters: 'search/setSearchFilters',
      vxResetSearchResults: 'search/resetSearchResults',
    }),
  },
}
